export const phoneRegex = /^(0|\+84)(\d{9})$/
export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const isEmail = (value: string): boolean => {
  return emailRegex.test(value);
};

export const isPhone = (value: string): boolean => {
  return phoneRegex.test(value);
};
